import { RecentChatUpdateAction } from '../../../Actions/RecentChatActions';
import { chatSeenPendingMsg } from '../../../Actions/SingleChatMessageActions';
import { changeTimeFormat } from '../../../Helpers/Chat/RecentChat';
import { formatUserIdToJid, isLocalUser } from '../../../Helpers/Chat/User';
import { getMessageObjReceiver, getMessageObjReceiverEdited } from '../../../Helpers/Utility';
import Store from '../../../Store';
import SDK from '../../SDK';
import {
    CHAT_TYPE_GROUP,
    GROUP_UPDATE_ACTIONS,
    MSG_RECEIVE_STATUS,
    MSG_RECEIVE_STATUS_CARBON,
    MSG_SENT_SEEN_STATUS_CARBON,
} from '../../../Helpers/Chat/Constant';
import {
    isActiveConversationUserOrGroup,
    notificationMessageType,
    isSingleChat,
    isGroupChat,
    getChatHistoryMessagesData,
    getRecentChatMessagesData,
    getActiveConversationChatId,
} from '../../../Helpers/Chat/ChatHelper';
import * as UnreadManager from '../../../Helpers/Chat/UnreadManager';
import { ChatMessageHistoryDataAction } from '../../../Actions/ChatHistory';
import { getFromLocalStorageAndDecrypt } from '../WebChatEncryptDecrypt';
import { MessageActionEdited } from '../../../Actions/MessageActions';

const getMessageSenderDetails = (newChatFrom, rosterDataArray) => {
    const rosterDetail = rosterDataArray.find(profile => {
        const rosterJid = profile.username ? profile.username : profile.jid;
        return newChatFrom === rosterJid;
    });
    return rosterDetail || { contactNumber: newChatFrom };
};

export const updateRecentChatMessage = (messgeObject, stateObject) => {
    const { recentChatData, rosterData } = stateObject;
    const { data: rosterDataArray = [] } = rosterData;
    const { rosterData: { recentChatNames } = {} } = recentChatData;
    const {
        msgType,
        fromUserId,
        fromUserJid,
        toUserId,
        msgId,
        timestamp: originalTimestamp,
        chatType,
        msgBody,
        publisherId,
        editedStatus = 0,
        msgStatus,
        deleteStatus,
        archiveStatus,
        userId,
        profileUpdatedStatus,
    } = messgeObject;

    // Normalize timestamp to 13 digits (milliseconds) if it's in microseconds (16 digits)
    let timestamp = originalTimestamp;
    if (timestamp && timestamp.toString().length === 16) {
        timestamp = Math.floor(timestamp / 1000);
    }

    const newChatTo = msgType === 'carbonSentMessage' ? toUserId : fromUserId;
    const newChatFrom = chatType === 'groupchat' ? publisherId : fromUserId;
    const updateTime = changeTimeFormat(timestamp);
    const userDetails = getMessageSenderDetails(newChatFrom, rosterDataArray);

    //get RecentChatData from Store
    const recentStoreData = getRecentChatMessagesData();
    const existingRecentMsg = recentStoreData?.find(messageObject => msgId === messageObject.msgId);
    const mappedResult = !!existingRecentMsg;
    /**
     * update the chat message if message alredy exist in recent chat
     */
    if (recentChatNames && recentChatNames?.indexOf(newChatTo) !== -1) {
        let constructNewMessage = {};
        if (editedStatus === 1) {
            constructNewMessage = {
                ...messgeObject,
                chatType: chatType,
                contactDetails: userDetails,
                editedStatus: editedStatus,
                filterBy: newChatTo,
                fromUserId: newChatTo,
                MessageType: msgType || msgBody.message_type || '',
                msgType: msgBody.message_type ? msgBody.message_type : msgType,
                publisher: newChatFrom,
                publisherId: newChatFrom,
                timestamp,
                reactions: existingRecentMsg?.reactions || [],
                reactedUserName: existingRecentMsg?.reactedUserName,
                emojiId: existingRecentMsg?.emojiId,
                messageSenderId: existingRecentMsg?.messageSenderId,
            };
        } else {
            constructNewMessage = {
                ...messgeObject,
                MessageType: msgType || msgBody.message_type || '',
                msgType: msgBody.message_type ? msgBody.message_type : msgType,
                publisher: newChatFrom,
                publisherId: newChatFrom,
                filterBy: newChatTo,
                fromUserId: newChatTo,
                chatType: chatType,
                contactDetails: userDetails,
                createdAt: updateTime,
                timestamp,
                editedStatus: editedStatus,
            };
        }
        if ((mappedResult === false && editedStatus === 0) || (mappedResult === true && editedStatus === 1)) {
            Store.dispatch(RecentChatUpdateAction(constructNewMessage));
        }
    } else {
        /**
         * New chat that is not alreay exist in recent chat
         */
        const getMute = getFromLocalStorageAndDecrypt('tempMuteUser');
        let parserLocalStorage = getMute ? JSON.parse(getMute) : {};
        const isMuted = parserLocalStorage[newChatTo]?.isMuted ? 1 : 0;
        const newMessage = {
            archiveStatus: editedStatus === 1 ? archiveStatus : 0,
            chatType: chatType,
            editedStatus: editedStatus,
            msgBody: msgBody,
            msgId: msgId,
            msgStatus: editedStatus === 1 ? msgStatus : 0,
            muteStatus: isMuted,
            msgType: msgBody.message_type ? msgBody.message_type : msgType,
            deleteStatus: editedStatus === 1 ? deleteStatus : 0,
            fromUserId: newChatTo,
            timestamp: timestamp,
            publisher: newChatFrom,
            publisherId: newChatFrom,
            toUserId: toUserId,
            createdAt: updateTime,
            filterBy: newChatTo,
            userId,
            profileUpdatedStatus,
        };
        Store.dispatch(RecentChatUpdateAction(newMessage));
    }
    if (!msgType && msgType === 'receiveMessage' && (msgBody === '4' || msgBody === '2')) {
        SDK.getGroupProfileUpdate(fromUserJid);
    }
};

export const updateConversationMessage = (messgeObject, currentState) => {
    try {
        const newChatTo =
            messgeObject.msgType === 'carbonSentMessage' ? messgeObject.toUserId : messgeObject.fromUserId;
        const singleChat = isSingleChat(messgeObject.chatType);
        const editedStatus = messgeObject?.editedStatus || 0;
        const editMessageId = messgeObject?.editMessageId || '';
        const UnreadUserObjData = Store.getState().UnreadUserObjData;

        // Handle active conversation seen status
        if (isActiveConversationUserOrGroup(newChatTo)) {
            const publisherId = singleChat ? newChatTo : messgeObject.publisherId;
            const msgTypeIdx = [MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON].indexOf(messgeObject.msgType);
            if (msgTypeIdx > -1) {
                const visible = !!(
                    currentState &&
                    currentState.browserTabData &&
                    currentState.browserTabData.isVisible
                );
                const groupId = singleChat ? '' : newChatTo;
                const unreadForFrom = UnreadUserObjData?.[messgeObject.fromUserId];
                const shouldSendSeen = !unreadForFrom || unreadForFrom.count === 0;
                if (visible) {
                    if (shouldSendSeen) {
                        const { privacySettingsData } = Store.getState();
                        const messageReceiptStatus = messgeObject.msgBody?.receipt_status === '1';
                        const userSeenReceiptEnabled = privacySettingsData.seenReceipt === 1;
                        const seen_receipt = messageReceiptStatus && userSeenReceiptEnabled ? '1' : '0';
                        SDK.sendSeenStatus(formatUserIdToJid(publisherId), messgeObject.msgId, groupId, seen_receipt);
                    }
                } else {
                    Store.dispatch(chatSeenPendingMsg(messgeObject));
                }
            }
            if (
                GROUP_UPDATE_ACTIONS.indexOf(messgeObject?.profileUpdatedStatus) &&
                !isLocalUser(messgeObject.publisherId)
            ) {
                SDK.updateRecentChatUnreadCount(messgeObject?.fromUserJid, messgeObject?.msgId);
            }
        } else if (!isLocalUser(messgeObject.publisherId)) {
            // If the Chat is Already Opened but if it is Not Currently Active, Store the Messages for Sending Seen Status
            Store.dispatch(chatSeenPendingMsg(messgeObject));
        }

        // Now handle conversation history insertion/update
        const conversationHistory = getChatHistoryMessagesData();
        let conversationChatObj = {};
        if (Object.keys(conversationHistory).includes(newChatTo)) {
            if (editedStatus === 1) {
                //Incase of server gives updated time, time handled from storeData
                conversationChatObj = getMessageObjReceiverEdited(messgeObject, newChatTo, conversationHistory);
                const constructedObj = {
                    ...conversationChatObj,
                    editMessageId: editMessageId && editMessageId !== messgeObject?.msgId ? editMessageId : '',
                };
                Store.dispatch(MessageActionEdited(constructedObj));
            } else {
                conversationChatObj = getMessageObjReceiver(messgeObject, messgeObject.fromUserId);
            }

            const dispatchData = {
                data: [conversationChatObj],
                ...(singleChat
                    ? { userJid: formatUserIdToJid(newChatTo) }
                    : { groupJid: formatUserIdToJid(newChatTo, CHAT_TYPE_GROUP) }),
            };
            Store.dispatch(ChatMessageHistoryDataAction(dispatchData));
        }
    } catch (err) {
        console.error('Error in updateConversationMessage:', err);
    }
};

/**
 * Update all delivered message seen status
 */
export const updateMsgSeenStatus = () => {
    const state = Store.getState();
    if (state?.activeChatData?.data?.recent) {
        const pendingMessages = state?.chatSeenPendingMsgData?.data || [];
        pendingMessages.forEach(message => {
            const fromUserId = isGroupChat(message.chatType) ? message.publisherId : message.fromUserId;
            const groupId = isGroupChat(message.chatType) ? message.fromUserId : '';
            if (isActiveConversationUserOrGroup(message.fromUserId)) {
                if (GROUP_UPDATE_ACTIONS.indexOf(message?.profileUpdatedStatus) > -1) {
                    if (!isLocalUser(message.publisherId)) SDK.updateRecentChatUnreadCount(message?.fromUserJid, message?.msgId);
                } else {
                    const UnreadUserObjData = Store.getState().UnreadUserObjData;
                    if (
                        !UnreadUserObjData[message.fromUserId] ||
                        UnreadUserObjData[message.fromUserId]?.count === 0
                    ) {
                        const { privacySettingsData } = Store.getState();
                        const messageReceiptStatus = message.msgBody?.receipt_status === '1';
                        const userSeenReceiptEnabled = privacySettingsData.seenReceipt === 1;
                        const seen_receipt = messageReceiptStatus && userSeenReceiptEnabled ? '1' : '0';
                        SDK.sendSeenStatus(formatUserIdToJid(fromUserId), message.msgId, groupId, seen_receipt);
                    }
                }
            }
        });
    }
};

const countedUnreadMsgIds = new Set();
const COUNTED_UNREAD_MSGID_LIMIT = 2000;
const markUnreadCounted = msgId => {
    if (!msgId) return true;
    if (countedUnreadMsgIds.has(msgId)) return false;
    countedUnreadMsgIds.add(msgId);
    if (countedUnreadMsgIds.size > COUNTED_UNREAD_MSGID_LIMIT) {
        countedUnreadMsgIds.delete(countedUnreadMsgIds.values().next().value);
    }
    return true;
};

const isMessageAlreadyKnown = (fromUserId, msgId) => {
    if (!fromUserId || !msgId) return false;
    const history = getChatHistoryMessagesData();
    return !!(history && history[fromUserId] && history[fromUserId].messages && history[fromUserId].messages[msgId]);
};

const isConversationAtBottom = () => {
    const el = document.getElementById('message-containner');
    if (!el) return false;
    return el.scrollHeight - el.scrollTop - el.clientHeight <= 150;
};

export const updateMessageUnreadCount = (messgeObject, stateObject) => {
    const { msgType, fromUserId, fromUserJid, publisherId, msgBody, toUserId, groupId, msgId } = messgeObject;
    const editedStatus = messgeObject?.editedStatus || 0;
    const isReceiveCountType =
        [MSG_RECEIVE_STATUS, MSG_RECEIVE_STATUS_CARBON].indexOf(msgType) > -1 &&
        !isLocalUser(publisherId) &&
        notificationMessageType.indexOf(msgBody) === -1 &&
        editedStatus === 0;
    if (isReceiveCountType) {
        const alreadyKnown = isMessageAlreadyKnown(fromUserId, msgId);
        const okToCount = !alreadyKnown && markUnreadCounted(msgId);
        if (okToCount) {
            const activeConversationId = getActiveConversationChatId();
            const isActive = activeConversationId && activeConversationId === fromUserId;
            const tabVisible = Store.getState()?.browserTabData?.isVisible ?? true;
            const isActiveInView = !!(isActive && tabVisible && isConversationAtBottom());
            UnreadManager.onLiveMessage(fromUserId, {
                msgId,
                ts: messgeObject.timestamp,
                chatJid: fromUserJid,
                groupId: isGroupChat(messgeObject.chatType) ? fromUserId : '',
                isActiveChat: !!isActive,
                isActiveInView,
            });
        }
    }

    if ([MSG_SENT_SEEN_STATUS_CARBON].indexOf(msgType) > -1) {
        const updateId = groupId || toUserId;
        UnreadManager.localClear(updateId);
    }
};